import React from 'react';
import moment from 'moment';
import 'moment-duration-format';
import { TextMedium, TextMediumLarge } from '../../common/text';
import { Logger } from 'common/logger';
import { Content, Col, PaddedRow } from './TooltipContent.styles';
import { DURATION_FORMAT, TIME_FORMAT, TIME_WITH_DATE_FORMAT } from '../../common/constants';

export const TurbineReleaseTooltipContent = ({ data }) => {
    if (!data || !data.turbineData) {
        Logger.log('No data for tooltip');
        return null;
    }

    const { beginDate, turbineData } = data;
    const { awp_nr, end_time, gridKey, release_time, return_time, start_time, turbineKey, woc_nr } = turbineData;
    const start = release_time || start_time;
    const end = return_time || end_time;
    const returnTime = moment(end).format(TIME_FORMAT);
    const releaseTime = moment(start).format(start < beginDate ? TIME_WITH_DATE_FORMAT : TIME_FORMAT);
    const duration = moment.duration(moment(end).diff(moment(start))).format(...DURATION_FORMAT);

    return (
        <Content>
            <PaddedRow>
                <Col>
                    <TextMediumLarge bold>{turbineKey}</TextMediumLarge>
                </Col>
                <Col>
                    <TextMedium color="gray2">{gridKey || '-'}</TextMedium>
                </Col>
                <Col>
                    <TextMedium>&nbsp;</TextMedium>
                </Col>
                <Col>
                    <TextMedium>&nbsp;</TextMedium>
                </Col>
            </PaddedRow>
            <PaddedRow>
                <Col>
                    <TextMedium caps color="gray2">
                        People
                    </TextMedium>
                    <TextMedium>-</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        Release time
                    </TextMedium>
                    <TextMedium>{releaseTime}</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        Return time
                    </TextMedium>
                    <TextMedium>{returnTime}</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        Duration
                    </TextMedium>
                    <TextMedium>{duration}</TextMedium>
                </Col>
            </PaddedRow>
            <PaddedRow>
                <Col>
                    <TextMedium caps color="gray2">
                        Proc. no
                    </TextMedium>
                    <TextMedium>{awp_nr}</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        WOC NO
                    </TextMedium>
                    <TextMedium>{woc_nr}</TextMedium>
                </Col>
            </PaddedRow>
        </Content>
    );
};
